import { z } from 'zod';
import { decode } from './zodDecoder';

const ExternalUserC = z.object({
    id: z.string(),
    account_id: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    email: z.string().nullish(),
    phone_number: z.string().nullish(),
    preferred_login: z.string(),
    preferred_language: z.string(),
    group_ids: z.array(z.string()),
    //    ... other fields currently ignored
});
const UserC = z.object({
    id: z.string(),
    accountId: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string().nullish(),
    phoneNumber: z.string().nullish(),
    preferred_login: z.string(),
    preferredLanguage: z.string(),
    groupIds: z.array(z.string()),
    //    ... other fields currently ignored
});
const ResourceListLinksC = z.object({
    next: z.object({ href: z.string() }).optional(),
});
const UsersApiResponseC = z.object({ items: z.array(ExternalUserC), _links: ResourceListLinksC.optional() });
const AdminUsersApiResponseC = z.array(ExternalUserC);
const UserGroupC = z.object({
    id: z.string(),
    name: z.string(),
    //    ... other fields currently ignored
});
const UserGroupsResponseC = z.object({ items: z.array(UserGroupC), _links: ResourceListLinksC.optional() });

const AccountSettingC = z.object({
    min_account_acr: z.string(),
});

export type AccountSetting = z.infer<typeof AccountSettingC>;
export type ExternalUser = z.infer<typeof ExternalUserC>;
export type User = z.infer<typeof UserC>;
export type UsersApiResponse = z.infer<typeof UsersApiResponseC>;
export type AdminUsersApiResponse = z.infer<typeof AdminUsersApiResponseC>;
export type UserGroup = z.infer<typeof UserGroupC>;
export type UserGroupsResponse = z.infer<typeof UserGroupsResponseC>;

export const decodeUserResponse = (parsedObject: unknown): ExternalUser => decode(parsedObject, ExternalUserC);
export const decodeUsersApiResponse = (parsedObject: unknown): UsersApiResponse =>
    decode(parsedObject, UsersApiResponseC);
export const decodeAdminUsersApiResponse = (parsedObject: unknown): AdminUsersApiResponse =>
    decode(parsedObject, AdminUsersApiResponseC);

export const decodeUserGroupsResponse = (parsedObject: unknown): UserGroupsResponse =>
    decode(parsedObject, UserGroupsResponseC);

export const decodeAccountSettingResponse = (parsedObject: unknown): AccountSetting => {
    return decode(parsedObject, AccountSettingC);
};

export const mapExternalToInternalUser = (externalUser: ExternalUser): User => ({
    id: externalUser.id,
    accountId: externalUser.account_id,
    firstName: externalUser.first_name,
    lastName: externalUser.last_name,
    email: externalUser.email,
    phoneNumber: externalUser.phone_number,
    preferred_login: externalUser.preferred_login,
    preferredLanguage: externalUser.preferred_language,
    groupIds: externalUser.group_ids,
});

export const decodeAndConvertAdminUsersApiResponse = (rawResult: unknown): User[] =>
    decodeAdminUsersApiResponse(rawResult).map(mapExternalToInternalUser);
